/* eslint-disable react/no-danger */

import classNames from 'classnames';

const LegendContentNode = document.getElementById('legend-content');

const InnerHTML = {__html: LegendContentNode.innerHTML};

const Legend = ({show}) => (
    <div
        id="panel-legend"
        className={classNames('container', {show})}
        dangerouslySetInnerHTML={InnerHTML}
    />
);

export default Legend;
